import { Form, Formik } from 'formik';
import { Link } from '@carvana/stc-styles';
import {
  ActionButton,
  ActionRow,
  ContentWrapper,
  GetSupport,
  HorizontalRule,
  LeadIn,
  SkipButton,
  StyledHeader
} from '../../theme/styles';
import { DefaultSurveyProps, SurveyValues } from '../../types';
import TextArea from '../TextArea/TextArea';
import Reactions from './Reactions';

const DefaultSurvey = ({
  commentBoxTitle,
  isLoading,
  onClose,
  onSubmit,
  title
}: DefaultSurveyProps) => {
  const handleSubmit = (values: SurveyValues) => {
    onSubmit(values);
  };

  return (
    <ContentWrapper>
      <Formik initialValues={{ comment: '', reaction: '' }} onSubmit={handleSubmit}>
        <Form>
          <LeadIn>Hello! We’d love to hear from you.</LeadIn>
          <HorizontalRule />
          <StyledHeader>{title}</StyledHeader>
          <Reactions name="reaction" />
          <HorizontalRule />
          <TextArea
            label={commentBoxTitle || 'Anything else you’d like to share?'}
            name="comment"
            placeholder="Share your ideas and feedback..."
          />
          <GetSupport>
            Need help?&nbsp;
            <Link href="/help" target="_blank" onClick={onClose}>
              Get support
            </Link>
          </GetSupport>
          <ActionRow>
            <SkipButton type="button" disabled={isLoading} onClick={onClose}>
              Skip
            </SkipButton>
            <ActionButton type="submit" disabled={isLoading}>
              Send Feedback
            </ActionButton>
          </ActionRow>
        </Form>
      </Formik>
    </ContentWrapper>
  );
};

export default DefaultSurvey;
